<template>
  <li class="schedule-item" :class="{'setting-select':selectItem}">
    <div class="s-item s-item1">
      <div class="item-index">{{index+1}}</div>
      <div class="item-delete" @click="$emit('deleteSchedule', index)">{{$t('cspm7')}}</div>
    </div>
    <div class="s-item s-item2">
      <div class="s-item-title" style="font-size: 14px; color: #606266;">{{$t('csl16')}}:</div>
      <!-- <el-time-picker
        size="mini"
        is-range
        arrow-control
        v-model="scheduleData.time"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        placeholder="选择时间范围"
        style="width: 240px"
        :editable="false"
      ></el-time-picker>-->
      <el-time-picker
        size="mini"
        style="width: 109px"
        :editable="false"
        :clearable="false"
        arrow-control
        v-model="scheduleData.time[0]"
      ></el-time-picker>
      <span style="font-size: 12px;">{{$t('cscs1')}}</span>
      <el-time-picker
        size="mini"
        style="width: 109px"
        :editable="false"
        :clearable="false"
        arrow-control
        v-model="scheduleData.time[1]"
      ></el-time-picker>
    </div>
    <div class="s-item s-item3">
      <div class="s-item-title">
        <el-checkbox v-model="scheduleData.DateLimit">{{$t('cscs2')}}:</el-checkbox>
      </div>
      <!-- 开始日期 -->
      <el-date-picker
        size="mini"
        style="width: 109px"
        :editable="false"
        :clearable="false"
        :disabled="!scheduleData.DateLimit"
        v-model="scheduleData.date[0]"
        type="date"
        :placeholder="$t('cscs3')"
      ></el-date-picker>
      <span style="font-size: 12px;">{{$t('cscs1')}}</span>
      <!-- 结束日期 -->
      <el-date-picker
        size="mini"
        style="width: 109px"
        :editable="false"
        :clearable="false"
        :disabled="!scheduleData.DateLimit"
        v-model="scheduleData.date[1]"
        type="date"
        :placeholder="$t('cscs3')"
      ></el-date-picker>
      <!-- <el-date-picker
        size="mini"
        v-model="scheduleData.date"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px"
        :picker-options="pickerOptions"
        :disabled="!scheduleData.DateLimit"
        :editable="false"
      ></el-date-picker>-->
    </div>
    <div class="s-item s-item4">
      <div class="s-item-title">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="weekAll"
          :disabled="weeksLimit.length < 7 && scheduleData.DateLimit"
          @change="handleCheckAllChange"
        >{{$t('cscs4')}}:</el-checkbox>
      </div>
      <el-checkbox-group
        v-model="scheduleData.weekSelect"
        @change="handleCheckedWeekesChange"
        size="mini"
        style="width: 240px"
      >
        <el-checkbox-button
          v-for="week in weeks"
          :label="week"
          :key="week"
          :disabled="weekLimited(week) && scheduleData.DateLimit"
        >{{week}}</el-checkbox-button>
      </el-checkbox-group>
    </div>
  </li>
</template>

<script>
import { dateFormatting, timeFormatting, weekFormatting, reDateFormatting, reTimeFormatting, reWeekFormatting } from "@/assets/scripts/dateFormatting";
// , reDateFormatting, reTimeFormatting, reWeekFormatting
const weeks = ['日', '一', '二', '三', '四', '五', '六'];
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    scheduleItem: {
      type: Object,
      default: () => { }
    },
    selectItem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scheduleData: {
        time: [reTimeFormatting(this.scheduleItem.startTime), reTimeFormatting(this.scheduleItem.endTime)],
        date: [reDateFormatting(this.scheduleItem.dateStart), reDateFormatting(this.scheduleItem.dateEnd)],
        weekSelect: reWeekFormatting(this.scheduleItem.validWeek),
        DateLimit: Boolean(parseInt(this.scheduleItem.isDateLimit))
      },
      weeks,
      weeksLimit: [],
      weekAll: Boolean(parseInt(this.scheduleItem.isWeekLimit)),
      isIndeterminate: false,
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() < Date.now() - 8.64e7;
      //   }
      // }
    };
  },
  created() {
    this.weeksLimit = [weeks[new Date().getDay()]];
    this.scheduleInit(this.scheduleItem);
  },
  methods: {
    scheduleInit(sItem) {
      console.log(sItem);
      this.weeksLimit = [];
      this.isIndeterminate = false;
      let dateStart = new Date(this.scheduleData.date[0].getTime());
      let dateEnd = new Date(this.scheduleData.date[1].getTime());
      // console.log(dateStart, dateEnd);
      while (dateStart.getTime() <= dateEnd.getTime() && this.weeksLimit.length < 7) {
        let week = weeks[dateStart.getDay()];
        let index = this.weeksLimit.findIndex(item => item === week);
        if (index === -1) {
          this.weeksLimit.push(week);
        }
        dateStart.setDate(dateStart.getDate() + 1);
      }
      // 当读取的数据为空时，则为新的排程，默认使用初始化数据，当有值时，则为修改排程。
      if (sItem.dateStart === "" && sItem.startTime === "") {
        this.scheduleData = {
          time: [new Date(), new Date()],
          date: [
            new Date(new Date(new Date().toLocaleDateString()).getTime()),
            new Date(new Date(new Date().toLocaleDateString()).getTime())
          ],
          weekSelect: [],
          DateLimit: true
        }
      }
    },
    handleCheckAllChange(val) {
      this.scheduleData.weekSelect = val ? weeks : [];
      this.isIndeterminate = false;
    },
    handleCheckedWeekesChange(value) {
      let checkedWeek = value.length;
      this.weekAll = checkedWeek === this.weeks.length;
      this.isIndeterminate = checkedWeek > 0 && checkedWeek < this.weeks.length;
    },
    saveData(e) {
      console.log(e);
    },
    weekLimited(week) {
      let index = this.weeksLimit.findIndex(item => item === week);
      return index === -1;
    }
  },
  watch: {
    scheduleData: {
      // eslint-disable-next-line no-unused-vars
      handler(newDate, oldDate) {
        console.log(newDate, oldDate);
        this.scheduleItem.startTime = timeFormatting(newDate.time[0]);
        this.scheduleItem.endTime = timeFormatting(newDate.time[1]);
        this.scheduleItem.isDateLimit = newDate.DateLimit;
        this.scheduleItem.dateStart = dateFormatting(newDate.date[0]);
        this.scheduleItem.dateEnd = dateFormatting(newDate.date[1]);
        this.scheduleItem.validWeek = weekFormatting(newDate.weekSelect);
        this.scheduleItem.isWeekLimit = this.scheduleItem.validWeek > 0;
        this.$emit('editSchedule', this.scheduleItem, this.index);
      },
      deep: true,
      // immediate: true
    },
    'scheduleData.date': {
      // eslint-disable-next-line no-unused-vars
      handler(newDate, oldDate) {
        // console.log(newDate, oldDate);
        // const weeks = ['日', '一', '二', '三', '四', '五', '六'];
        this.weeksLimit = [];
        this.scheduleData.weekSelect = [];
        this.isIndeterminate = false;
        let dateStart = new Date(this.scheduleData.date[0].getTime());
        let dateEnd = new Date(this.scheduleData.date[1].getTime());
        // console.log(dateStart, dateEnd);
        while (dateStart.getTime() <= dateEnd.getTime() && this.weeksLimit.length < 7) {
          let week = weeks[dateStart.getDay()];
          let index = this.weeksLimit.findIndex(item => item === week);
          index === -1 && this.weeksLimit.push(week);
          dateStart.setDate(dateStart.getDate() + 1);
        }
        // console.log(this.weeksLimit);
      },
      deep: true,
      // immediate: true
    },
    'scheduleData.DateLimit': {
      // eslint-disable-next-line no-unused-vars
      handler(newDate, oldDate) {
        // console.log(newDate, oldDate);
        this.scheduleData.weekSelect = [];
        this.isIndeterminate = false;
        this.weekAll = false;
      },
      deep: true,
      // immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.setting-select {
  box-shadow: 0px 0px 4px 1px #ff8739;
}
.schedule-item {
  margin-bottom: 12px;
  width: 310px;
  height: 240px;
  border-radius: 20px;
  border: solid 1px #cfd5d8;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 6px 0px;
  .s-item {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .s-item-title {
      width: 60px;
      display: flex;
      justify-content: flex-end;
    }
  }
  .s-item1 {
    justify-content: space-between;
    height: 22px;
    .item-index {
      width: 44px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      background-image: linear-gradient(
          270deg,
          #86eae7 0%,
          #4cccf0 45%,
          #11adf8 100%
        ),
        linear-gradient(#35cafa, #35cafa);
      background-blend-mode: normal, normal;
      border-radius: 0px 11px 11px 0px;
      color: #fff;
    }
    .item-delete {
      width: 44px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      background-image: linear-gradient(
          270deg,
          #ff907e 0%,
          #ff7878 45%,
          #ff5f72 100%
        ),
        linear-gradient(#ffffff, #ffffff);
      background-blend-mode: normal, normal;
      border-radius: 11px 0px 0px 11px;
      color: #fff;
    }
  }
  .s-item2 {
    height: 40px;
  }
  .s-item3 {
    height: 40px;
    /deep/ .el-input__inner {
      padding-right: 10px;
    }
  }
  .s-item4 {
    height: 80px;
    .el-checkbox-button {
      padding: 6px;
    }
    /deep/ .el-checkbox-button__inner {
      border-radius: 4px;
      border: 1px solid #35cafa;
    }
  }
}
</style>
